import { render, staticRenderFns } from "./InventoryTransferSuggestions.vue?vue&type=template&id=cb56affe&scoped=true"
import script from "./InventoryTransferSuggestions.vue?vue&type=script&lang=ts"
export * from "./InventoryTransferSuggestions.vue?vue&type=script&lang=ts"
import style0 from "./InventoryTransferSuggestions.vue?vue&type=style&index=0&id=cb56affe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb56affe",
  null
  
)

export default component.exports